import React from "react";

import { Box } from "@chakra-ui/react";

const ContentCard = ({
  children,
  m = "0",
  w = "auto",
  overflow = "visible",
}) => {
  return (
    <Box
      className="content-card"
      borderRadius="lg"
      bg="white"
      p={["4", "1rem"]}
      borderTop="solid"
      borderColor="#3498DB"
      m={m}
      w={w}
      mb="1rem"
      overflow={overflow}
    >
      {children}
    </Box>
  );
};

export default ContentCard;
